import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  CardTitle,
  Card,
  StyledParagraph,
  StyledH3,
  Copy,
  CopyText,
  CopyButton,
} from "./ReferralStyle";

type ReferralCodeCardProps = {
  referralCode: string;
  refererName: string;
};

const ReferralCodeCard = ({
  referralCode,
  refererName,
}: ReferralCodeCardProps) => {
  const { t } = useTranslation("referral");

  const [copied, setCopied] = useState(false);

  return (
    <>
      <CardTitle>{t("Welcome to flexi classes").toUpperCase()}</CardTitle>
      <Card>
        <StyledParagraph>
          {refererName
            .substring(0, 1)
            .toUpperCase()
            .concat(refererName.substring(1))
            .concat(t(" invited you to join them in learning a new language."))}
          <br />
          {t("Register now and get 5 free group classes.")}
        </StyledParagraph>
        <StyledH3>{t("YOUR DISCOUNT CODE").toUpperCase()}</StyledH3>
        <Copy>
          <CopyText>{referralCode}</CopyText>
          <CopyButton
            onClick={() => {
              navigator.clipboard.writeText(referralCode);
              setCopied(true);
            }}
            disabled={copied}
          >
            {copied ? t("Copied!") : t("Copy")}
          </CopyButton>
        </Copy>
      </Card>
    </>
  );
};

export default ReferralCodeCard;
